import React from "react";
import { StyleSheet, View, Image, TouchableOpacity } from "react-native";
import * as Animatable from "react-native-animatable";
import { widthPercentageToDP } from "react-native-responsive-screen";
import theme from "app/Theme/Theme";
import {
  getLanguage,
  getProfileSettingsMbti,
} from "@microdoing/shared/services/profileSettings/selectors";
const jouviePicture = require("../../../assets/images/jouvie.png");
const rightJouviePicture = require("../../../assets/images/right-jouvie.png");
import { useSelector } from "react-redux";
const Jouvie3D = require("../../../assets/images/Jouvie3D.png");
import { getMbtiOptions } from "../../scenes/UserProfile/MbtiSelectorScreen/MbtiLibrary";
import { Box, MainText } from "mobile/src/components/common";

const styles = StyleSheet.create({
  main: {
    height: "80%",
    width: widthPercentageToDP("100%"),
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  picture: {
    height: 110,
    width: 40,
    marginLeft: 0,
  },
  textView: {
    position: "absolute",
    width: widthPercentageToDP("100%"),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  noMessage: {
    fontSize: 16,
    textAlign: "center",
    color: theme.colors["neutral.900"],
  },
  firstMessage: {
    fontSize: 16,
    textAlign: "center",
    color: theme.colors["brand.500"],
    fontWeight: "bold",
  },
});

export interface IEmptyJouvie {
  onPress?: () => void;
  firstMessage?: string;
  secondMessage?: string;
  isRightJouvie?: boolean;
  style?: {};
}

const EmptyJouvie = ({
  onPress = () => {},
  firstMessage = "",
  secondMessage = "",
  isRightJouvie = false,
  style = {},
}) => {
  const userMbti = useSelector(getProfileSettingsMbti);
  const language = useSelector(getLanguage);
  const userMbtiData = getMbtiOptions(language).find(
    item => item.key === userMbti,
  );

  return (
    <Box
      height="80%"
      alignSelf="center"
      justifyContent="center"
      alignItems="center"
      useNativeDriver
      animation={"fadeInUp"}
    >
      <Box alignItems="center">
        <Image
          resizeMode="contain"
          source={!userMbti ? Jouvie3D : userMbtiData?.image}
          style={{ height: 100, width: 100, marginBottom: theme.spacing.xm }}
        />
        <MainText marginBottom="xs" variant="l4-bold">
          {firstMessage}
        </MainText>
        <TouchableOpacity onPress={onPress}>
          <MainText variant="l4-medium" style={styles.firstMessage}>
            {secondMessage}
          </MainText>
        </TouchableOpacity>
      </Box>
    </Box>
  );
};

export { EmptyJouvie };
